import { render } from "./InterServicios.vue?vue&type=template&id=51e79762&scoped=true"
import script from "./InterServicios.vue?vue&type=script&lang=js"
export * from "./InterServicios.vue?vue&type=script&lang=js"

import "./InterServicios.vue?vue&type=style&index=0&id=51e79762&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51e79762"]])

export default __exports__